import React from "react";

import { reais } from "../formato";

const limitar = (n) => Math.min(100, Math.max(0, n));

// Barra do preço cheio: a parte verde é o que o estabelecimento recebe no
// pior sorteio, a listrada é o desconto máximo. O traço marca o custo.
export default function ReguaPreco({ preco, minimo, custo, className = "" }) {
  const p = Number(preco) || 0;
  if (!(p > 0)) return null;
  const larguraMin = limitar((minimo / p) * 100);
  const temCusto = custo != null && Number(custo) > 0;
  const furou = temCusto && minimo < custo;
  return (
    <div className={className} data-e2e="regua-preco">
      <div className="relative">
        <div className="h-2.5 rounded-full overflow-hidden flex bg-muted">
          <div className={furou ? "bg-red-500" : "bg-emerald-500"} style={{ width: `${larguraMin}%` }} />
          <div className="flex-1 bg-amber-400"
            style={{ backgroundImage: "repeating-linear-gradient(135deg, transparent 0 3px, rgba(255,255,255,.45) 3px 6px)" }} />
        </div>
        {temCusto && (
          <div className="absolute -top-1 h-[18px] w-0.5 rounded bg-foreground" style={{ left: `calc(${limitar((custo / p) * 100)}% - 1px)` }}
            title={`Custo ${reais(custo)}`} />
        )}
      </div>
      <div className="flex flex-wrap justify-between gap-x-3 gap-y-0.5 mt-1 text-[10px] leading-tight text-muted-foreground tabular-nums">
        <span><span className={`inline-block w-2 h-2 rounded-sm mr-1 ${furou ? "bg-red-500" : "bg-emerald-500"}`} />recebe no mínimo</span>
        {temCusto && <span>▎custo {reais(custo)}</span>}
        <span><span className="inline-block w-2 h-2 rounded-sm mr-1 bg-amber-400" />desconto até {reais(p - minimo)}</span>
      </div>
    </div>
  );
}
